import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

const DonutChartAssociates = ({ associateData }) => {
    const [series, setSeries] = useState([]);
    const [chartOptions, setChartOptions] = useState({
        chart: {
            type: 'donut',
        },
        labels: [],
        legend: {
            show: false, // Disable default legend
        },
        colors: [], // Dynamically populated
        dataLabels: {
            enabled: false, // Fully disable data labels
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                    labels: {
                        show: false, // Hide default labels in the center
                    },
                },
                expandOnClick: false, // Disable expand on click
            },
        },
        tooltip: {
            enabled: true,
            theme: "light", // Match tooltip theme with DonutChartEvent
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
            },
        },
    });

    const generateColors = (numColors) => {
        const baseColors = ['#FF0000', '#0000FF', '#00FF00', '#FFFF00'];
        const additionalColors = [];
        const saturation = 50;
        const lightness = 90;

        for (let i = 0; i < numColors - baseColors.length; i++) {
            const hue = (i * 360) / (numColors - baseColors.length);
            additionalColors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
        }

        return [...baseColors, ...additionalColors].slice(0, numColors);
    };

    useEffect(() => {
        if (associateData && associateData.length > 0) {
            const labels = associateData.map((item) => item.associatesCategory);
            const data = associateData.map((item) => item.associateCount);

            setChartOptions((prevOptions) => ({
                ...prevOptions,
                labels: labels,
                colors: generateColors(labels.length),
            }));

            setSeries(data);
        } else {
            setSeries([]);
            setChartOptions((prevOptions) => ({
                ...prevOptions,
                labels: [],
            }));
        }
    }, [associateData]);

    return (
        <div
            id="donut-chart-associates"
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: series.length === 0 ? 'center' : undefined,
                height: '360px',
            }}
        >
            {series.length > 0 ? (
                <ReactApexChart
                    options={chartOptions}
                    series={series}
                    type="donut"
                    height={window.innerWidth <= 425 ? 180 : 320}
                />
            ) : (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '50vh',
                        fontSize: '18px',
                        color: '#666',
                        textAlign: 'center',
                    }}
                >
                    No data is available.
                </div>
            )}

            {series.length > 0 && (
                <div
                    style={{
                        marginTop: '20px',
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                    }}
                >
                    {associateData.map((item, index) => (
                        <div
                            key={index}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '5px 15px',
                            }}
                        >
                            <span
                                style={{
                                    width: '15px',
                                    height: '15px',
                                    backgroundColor: generateColors(associateData.length)[index],
                                    marginRight: '8px',
                                    borderRadius: '3px',
                                }}
                            ></span>
                            <span
                                style={{
                                    fontSize: '14px',
                                    color: '#333',
                                }}
                            >
                                {item.associatesCategory}:{' '}
                                {(
                                    (series[index] /
                                        series.reduce((a, b) => a + b, 0)) *
                                    100
                                ).toFixed(1)}
                                %
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DonutChartAssociates;
